import React from "react";
import Staff from "../Staff";

/**
 * Chat - Single chat message bubble in a conversation.
 * Uses native Date for timestamp formatting (sdate handles date-only, not time).
 *
 * @author opencode + glm-5.1
 * @date 2026-04-21
 * @version 2.0
 */
export default function Chat(props) {
  const { chat, user } = props;

  const isMine = chat.user && chat.user === user._id;

  const formatTime = (iso) => {
    const d = new Date(iso);
    const hh = String(d.getHours()).padStart(2, "0");
    const mm = String(d.getMinutes()).padStart(2, "0");
    const dd = String(d.getDate()).padStart(2, "0");
    const mo = String(d.getMonth() + 1).padStart(2, "0");
    return `${hh}:${mm}, ${dd}/${mo}`;
  };

  return (
    <div className={`chat-message-row ${isMine ? "chat-mine" : "chat-theirs"}`}>
      <div className={`chat-bubble ${isMine ? "bubble-mine" : "bubble-theirs"}`}>
        {!isMine && (
          <div className="chat-header">
            {chat.user && <Staff id={chat.user} />}
          </div>
        )}
        <div className="chat-content">{chat.message}</div>
        <div className="chat-timestamp">
          {formatTime(chat.createdAt)}
        </div>
      </div>
    </div>
  );
}
